import styled from 'styled-components';
import PetalIconSpace from '@assets/images/logo/petal_icon.svg'; 

export const PetalIconImg = styled(PetalIconSpace)`
`;
